import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

const ProtectedRoute = ({
  children,
  requireAdmin = false,
  requireCoach = false,
}) => {
  const location = useLocation();

  const { isAuthenticated, user } = useSelector((state) => state.auth);

  const userIsAdmin = user?.is_admin;
  const userIsCoach = user?.is_coach;

  console.log("ProtectedRoute Redux check:", {
    location: location.pathname,
    isAuthenticated: isAuthenticated,
    userIsAdmin: userIsAdmin,
    userIsCoach: userIsCoach,
    requireAdmin: requireAdmin,
    requireCoach: requireCoach,
  });

  if (!isAuthenticated) {
    console.log(
      "ProtectedRoute: Not authenticated (Redux), redirecting to login.",
      { from: location.pathname }
    );
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (requireAdmin && !userIsAdmin) {
    console.log(
      "ProtectedRoute: Admin role required (Redux), redirecting to unauthorized.",
      { location: location.pathname }
    );
    return <Navigate to="/unauthorized" replace />;
  }

  if (requireCoach && !userIsCoach) {
    console.log(
      "ProtectedRoute: Coach role required (Redux), redirecting to unauthorized.",
      { location: location.pathname }
    );
    return <Navigate to="/unauthorized" replace />;
  }

  console.log("ProtectedRoute: Access granted (Redux).", {
    location: location.pathname,
  });
  return children;
};

export default ProtectedRoute;
